/** Routes et compteurs UI — module Régularisations. */

export const REGULARISATION_PATHS = {
  cca: "/compta/regularisations/cca",
  pca: "/compta/regularisations/pca",
  cap: "/compta/regularisations/cap",
  par: "/compta/regularisations/par",
  fnp: "/compta/regularisations/fnp",
  fae: "/compta/regularisations/fae",
} as const;

export type RegularisationPathKey = keyof typeof REGULARISATION_PATHS;

/** Compteurs factices (UI) — à remplacer par des données réelles. */
export const REGULARISATION_UI_COUNTS: Record<RegularisationPathKey, number> = {
  cca: 0,
  pca: 0,
  cap: 0,
  par: 0,
  fnp: 0,
  fae: 0,
};
